const PLBTypes = {
  PLB_HEDGING: "plb-hedging",
  PLB_LOCQPAY: "plb-locqpay",
  PLB_LOCQPAY_MANUAL_PO: "plb-locqpay-manual-po",
  PLB_LOCQPAY_MANUAL_PO_CREDIT: "plb-locqpay-manual-po-credit",
};

export default PLBTypes;
